import { AlertTriangle } from 'lucide-react';
import { formatSubscriptionDate, getSubscriptionWarning } from '../../utils/academicYear';

export function SubscriptionExpiryBanner({ expiresAt, labels, role }) {
  const warning = getSubscriptionWarning(expiresAt);
  if (!warning?.show) return null;

  const dateStr = formatSubscriptionDate(expiresAt);
  const days = warning.days;

  let title = labels.subscriptionExpiringTitle;
  let message = labels.subscriptionExpiringMessage
    .replaceAll('{date}', dateStr)
    .replaceAll('{days}', String(days));

  if (warning.expired) {
    title = labels.subscriptionExpiredTitle;
    message = labels.subscriptionExpiredMessage.replaceAll('{date}', dateStr);
  } else if (warning.urgent) {
    title = labels.subscriptionExpiringUrgentTitle;
    message = labels.subscriptionExpiringUrgentMessage
      .replaceAll('{date}', dateStr)
      .replaceAll('{days}', String(days));
  }

  const boxClass = warning.expired || warning.urgent
    ? 'border-danger/40 bg-danger-bg text-danger'
    : 'border-warning/40 bg-warning-bg text-warning';

  return (
    <div
      className={`flex gap-3 rounded-lg border px-4 py-3 text-sm ${boxClass}`}
      role="alert"
    >
      <AlertTriangle className="h-5 w-5 shrink-0 mt-0.5" strokeWidth={2.25} />
      <div className="min-w-0 flex-1">
        <p className="font-semibold leading-snug">{title}</p>
        <p className="mt-1 leading-relaxed opacity-95">{message}</p>
        {role === 'teacher' && (
          <p className="mt-1.5 text-xs opacity-90">{labels.subscriptionExpiringTeacherNote}</p>
        )}
      </div>
    </div>
  );
}
